import { BaseElement, defineElement } from '@webtides/element-js';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock/lib/bodyScrollLock.es6';

import FlyoutElementEvent from './FlyoutElementEvent';

class FlyoutElement extends BaseElement {
    constructor() {
        super();
    }

    properties() {
        return {
            open: false,
        };
    }

    connected() {
        this.removeAttribute('cloak');
    }

    toggleBackdrop() {
        const backdrop = this.$refs.backdrop || this.querySelector('flyout-backdrop');
        if (backdrop) {
            backdrop.open = this.open;
        }
    }

    watch() {
        return {
            open: (_, after) => {
                this.classList.toggle('open', this.open);

                this.toggleBackdrop();

                if (this.open) {
                    disableBodyScroll(this.$refs.filterContent, {
                        reserveScrollBarGap: true,
                    });
                } else {
                    enableBodyScroll(this.$refs.filterContent);
                    this.dispatch(FlyoutElementEvent.FLYOUT_CLOSED, {}, true);
                }

                //sync backdrop
            },
        };
    }

    events() {
        return {
            'flyout-backdrop': {
                click: () => {
                    this.open = false;
                },
            },
            '[flyout-close]': {
                click: () => {
                    this.open = false;
                },
            },
        };
    }

    toggle() {
        this.open = !this.open;
    }
}

defineElement('flyout-element', FlyoutElement);
